<template>
    <div>
        <div v-if="logs.length > 0" class="products-list" >
            <div class="content-top row">
                <div class="col-24 d-flex justify-content-between align-items-center">
                    <div class="content-top__title-box">
                        <h1 class="content-top__heading">Aktywność użytkownika {{logs[0].wp_username}}</h1>
                    </div>
                    <div class="content-top__subwrap">
                        <div class="content-top__buttons">
                                <button class="button button--icon" @click.prevent="getUserLogsPdf()">
                                    <icon icon="save" icon-classes="button__icon button__icon--left icon--white" />
                                    <span class="button__text">Pobierz PDF</span>
                                </button>
                        </div>
                    </div>
                </div>
            </div>
            <div  class="content">

                <table class="items-table">

                    <thead class="items-table__thead">
                        <h3>Daty odwiedzin</h3>
                        <tr class="items-table__tr">


                            <th class="items-table__th">
                                Data
                            </th>


                        </tr>

                    </thead>

                    <tbody class="items-table__tbody">
                        
                        <template v-for="(logs, key) in logsByDay">
                            <tr class="items-table__tr" v-bind:key="key">

                                <td class="items-table__td">
                                    <router-link class="items-table__router-link" :to="{name: 'wpUserActivityDayLogs', params: {dayLogs: logs}}">
                                        {{key}}
                                    </router-link>
                                </td>

                                <td class="items-table__td pr-0">
                                    <div class="form-box__buttons">
                                        <button class="button-icon button-icon--ml-10" @click="getUserLogsOfDayPdf(key)" >
                                            <icon icon="save" icon-classes="icon--regular" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </template>

                    </tbody>
                </table>
            </div>

        </div>

        <div v-else class="content">
            Wróć do wyboru użytkownika ProMarmite
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
    import _ from 'lodash';
    import Icon from './parts/Icon';


    export default {
        props: [
            'user'
        ],
        components: {
            Icon,
        },
        data() {
            return {
                logs: {},
                logsByDay: {},
            }
        },

        async mounted() {
            await this.getUserLogs();
        },
        methods: {
            async getUserLogs() {
                try {
                    var params = {
                        'page': this.logs.current_page
                    };

                    const response = await axios.get(API_BASE_URL + '/wp-logs/' + this.user, {
                        params: params
                    });
                    this.logs = response.data.data.userLogs;
                    this.logsByDay = _.groupBy(this.logs, 'created_day');
                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            getUserLogsPdf() {
                try {
                    axios({
                        url: API_BASE_URL + '/pdf-wp-logs/' + this.user,
                        method: 'GET',
                        responseType: 'blob', // important
                    }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.logs[0].wp_username+'_all_logs.pdf');
                        document.body.appendChild(link);
                        link.click();
                    });
                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            getUserLogsOfDayPdf(day) {
                try {
                    axios({
                        url: API_BASE_URL + '/pdf-day-wp-logs/' + this.user,
                        params: {
                            day: day
                        },
                        method: 'GET',
                        responseType: 'blob', // important
                    }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.logs[0].wp_username + '_'+ day +'_logs.pdf');
                        document.body.appendChild(link);
                        link.click();
                    });
                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            showPreview(data) {
                let array = data;

                this.previewLog.id = data.id;
                this.previewLog.preview = array;

                this.showModal = true;
            },
        }
    }
</script>